export default __webpack_public_path__ + "static/media/message.83ee0619.png";